import PrioritySelect from "@/components/form/priority-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";
import type { ListItemPriority } from "@/types/openapi-enum";

export type PriorityFieldProps = PickerFieldProps<ListItemPriority>;

export const PriorityField = makePickerField<ListItemPriority>({
  name: "PriorityField",
  control: PrioritySelect,
  popout: true,
});
